
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/releases",
      function () {
        return require("private-next-pages/d/releases.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/releases"])
      });
    }
  